import {
  analyticAddZipDefinition,
  analyticEcommDefinition,
  analyticOnMountedDefinition,
  analyticShowImpression,
  analyticShowImpressionChange,
} from "./interfaces/analyticDefinitions";
import type { Directive } from "./interfaces/Directive";
import { registerLeadGenEvent } from "./interfaces/leadGenDefinitions";

/**
 * Directives to be registered
 */

const directives: Array<Directive> = [
  { Name: "analytic-push", Definition: analyticEcommDefinition },
  { Name: "analytic-add-zip", Definition: analyticAddZipDefinition },
  { Name: "analytic-impressions", Definition: analyticShowImpression },
  { Name: "analytic-impressions-change", Definition: analyticShowImpressionChange },
  { Name: "analytic-on-mounted", Definition: analyticOnMountedDefinition },
  { Name: "sync-interaction", Definition: registerLeadGenEvent },
];

export default directives;
